export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_SUCCESS = 'SET_CURRENT_USER_SUCCESS';
export const SET_CURRENT_USER_FAILURE = 'SET_CURRENT_USER_FAILURE';
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';
export const EXTEND_TOKEN_VALIDITY = 'EXTEND_TOKEN_VALIDITY';
export const EXTEND_TOKEN_VALIDITY_SUCCESS = 'EXTEND_TOKEN_VALIDITY_SUCCESS';
export const EXTEND_TOKEN_VALIDITY_FAILURE = 'EXTEND_TOKEN_VALIDITY_FAILURE';
export const USER_ACTIVITY = 'USER_ACTIVITY';
export const CHECK_TOKENS = 'CHECK_TOKENS';
export const EXPIRE_TOKEN = 'EXPIRE_TOKEN';
